import React, { useState } from 'react';
import { Play, Volume2 } from 'lucide-react';
interface VideoEmbedProps {
  videoId: string;
  title: string;
  thumbnailUrl?: string;
  autoplay?: boolean;
}
export function VideoEmbed({
  videoId,
  title,
  thumbnailUrl,
  autoplay = false
}: VideoEmbedProps) {
  const [isPlaying, setIsPlaying] = useState(autoplay);
  const [showUnmutePrompt, setShowUnmutePrompt] = useState(true);
  const placeholderImage = thumbnailUrl || `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  if (!isPlaying) {
    return <div className="relative w-full aspect-video bg-black rounded-xl overflow-hidden cursor-pointer group shadow-2xl border border-gray-800" onClick={() => setIsPlaying(true)} role="button" aria-label={`Play video: ${title}`} tabIndex={0} onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        setIsPlaying(true);
      }
    }} data-id="element-114">
        <img src={placeholderImage} alt={title} className="w-full h-full object-cover" data-id="element-115" />
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/40 group-hover:bg-black/50 transition-colors" data-id="element-116">
          {/* Unmute Prompt */}
          <div className="absolute top-6 left-1/2 -translate-x-1/2 bg-purple-600 text-white px-6 py-3 rounded-lg border-2 border-purple-400 shadow-lg" data-id="element-117">
            <p className="text-sm font-medium flex items-center gap-2" data-id="element-118">
              <Volume2 size={18} data-id="element-119" />
              Your video has already started
            </p>
            <p className="text-xs mt-1 text-purple-200" data-id="element-120">Click to listen</p>
          </div>

          {/* Play Button */}
          <div className="w-20 h-20 bg-[#D4FF00] rounded-full flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-200 mt-16" data-id="element-121">
            <Play className="w-8 h-8 text-black ml-1" fill="currentColor" data-id="element-122" />
          </div>
        </div>
      </div>;
  }
  return <div className="w-full aspect-video bg-black rounded-xl overflow-hidden shadow-2xl border border-gray-800" data-id="element-123">
      <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`} title={title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-124" />
    </div>;
}